import React, { Component } from 'react';
import { Card, Label, Button, FormGroup, CardHeader, CardBody, Row, Col, Table, Alert } from 'reactstrap';
import { numberWithCommas } from '../../lib/Utils';

import { Field, Form, reduxForm } from 'redux-form';

import { ReduxFileInput } from '../../components/ReduxInput';


class InvoiceForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      files: 0

    };

    this.addFile = this.addFile.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.saveQuote = this.saveQuote.bind(this);
  }

  addFile() {
    this.setState({
      files: this.state.files + 1
    });
  }

  removeFile() {
    this.setState((prevState) => {
      if (prevState.files != 0) {
        return {
          files: this.state.files - 1
        };
      } return prevState;

    }
    );
  }

  saveQuote(){

    const { quote, accessorials, terminalId } = this.props;

    let total = "$0.00";
    let baseRate = "$0.00";
    let destination = "Base Rate";

    let itemized = [];

    let note = "";
    if(accessorials){
      accessorials.forEach(access => {
        if(access.terminalId ===  terminalId){
          note = access.Note;
        }
      })
    }
    if (quote && quote.items) {
      let i = 0;
      itemized = quote.items.map((item) => {
        let num = parseFloat(Math.round(item.rate * 100) / 100).toFixed(2);
        return (
          <tr key={i++}>
            <td> {i}</td>
            <td className="text-center"><strong>{item.count}</strong></td>
            <td>{item.description}</td>
            <td>{"$" + numberWithCommas(num)}</td>
          </tr>
        );
      });

      total = "$" + numberWithCommas(quote.total);
      baseRate = "$" + numberWithCommas(parseFloat(Math.round(quote.baseRate.rate * 100) / 100).toFixed(2));
      destination = quote.baseRate.destination;
    }

    let myDate = new Date();
    let date = (myDate.getMonth() + 1) + "-" + myDate.getDate() + "-" + myDate.getFullYear();


    this.props.submitGetJobRequestPdf({
      terminalId, quote
    });
  }


  render() {
    const { quote, previous, handleSubmit, terminalName, remarks, accessorials, terminalId } = this.props;

    let total = "$0.00";
    let baseRate = "$0.00";
    let destination = "Base Rate";

    let itemized = [];

    let note = "";
    if(accessorials){
      accessorials.forEach(access => {
        if(access.terminalId ===  terminalId){
          note = access.Note;
        }
      })
    }
    if (quote && quote.items) {
      let i = 0;
      itemized = quote.items.map((item) => {
        let num = parseFloat(Math.round(item.rate * 100) / 100).toFixed(2);
        return (
          <tr key={i++}>
            <td> {i}</td>
            <td className="text-center"><strong>{item.count}</strong></td>
            <td>{item.description}</td>
            <td>{"$" + numberWithCommas(num)}</td>
          </tr>
        );
      });

      total = "$" + numberWithCommas(quote.total);
      baseRate = "$" + numberWithCommas(parseFloat(Math.round(quote.baseRate.rate * 100) / 100).toFixed(2));
      destination = quote.baseRate.destination;
    }

    let myDate = new Date();
    let date = (myDate.getMonth() + 1) + "-" + myDate.getDate() + "-" + myDate.getFullYear();


    let fields = [];
    for (let i = 0; i < this.state.files; i++) {
      fields.push(
        <FormGroup key={i}>
          <Field
            name={"file-" + i}
            type="file"
            component={ReduxFileInput} />
        </FormGroup>
      );
    }

    return (
      <div className="animated fadeIn">
        <Form onSubmit={handleSubmit} >
          <Card>
            <CardHeader>
              Quote
          </CardHeader>
            <CardBody>
              <Table striped responsive>
                <thead>
                  <tr>
                    <th className="center">#</th>
                    <th className="center">Quantity</th>
                    <th>Description</th>
                    <th className="center">Price</th>
                  </tr>
                </thead>
                <tbody>
                  {itemized}
                  <tr>
                    <td />
                    <td className="text-center"><strong>1</strong></td>
                    <td>{terminalName + " to " + destination || "Base Rate"}</td>
                    <td>{baseRate}</td>
                  </tr>
                </tbody>
              </Table>
              <Row>
              </Row>
              <Row>
                <Col lg="12" sm="5">
                  <strong>REMARKS :</strong>
                  <br/>
                  <span> {remarks} </span>
                  <br/>
                  <br/>
                </Col>
              </Row>
              <Row>
                <Col lg="4" sm="5">
                  <strong>QUOTE DATE :</strong>
                  <span className="pull-right"> <i className="fa fa-calendar"></i> {date} </span>
                </Col>
                <Col xs="12">
                  <strong>NOTES:</strong>
                </Col>
                <Col xs="12">
                <Alert color="success">
                  {note} 
                  </Alert>
                </Col>
                <Col className="pt-5" xs="12">

                  <Label> <strong>Attach files for submission </strong></Label>
                  {fields}
                  <FormGroup>
                    <i onClick={this.addFile} className="fa fa-plus fa-plus-hover" aria-hidden="true"></i>
                    {" / "}
                    <i onClick={this.removeFile} className="fa fa-minus fa-plus-hover" aria-hidden="true"></i>
                  </FormGroup>
                 
                </Col>
                <Col lg="4" sm="5" className="ml-auto">
                  <Table className="table-clear">
                    <tbody>
                      <tr>
                        <td className="left"><strong>Total</strong></td>
                        <td className="right"><strong id="total"> {total + " USD"}</strong></td>
                      </tr>
                    </tbody>
                  </Table>
                  <FormGroup>
                    <Button onClick={previous}
                      color="previous"
                    >Previous</Button>{' '}
                    <Button  onClick={this.saveQuote}
                      color="primary" className="text-white"
                    >Save Quote</Button>{' '}
                    <Button type="submit"
                      color="primary" className="text-white"
                    >Send New Job Request</Button>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Form>
      </div>
    );
  }
}


export default reduxForm({
  form: 'InvoiceForm', // a unique identifier for this form
})(InvoiceForm);




// WEBPACK FOOTER //
// ./src/components/InvoiceForm/InvoiceForm.js